import type { RouteLocationNormalizedLoaded } from 'vue-router';

export function useTypedRoute<R>() {
  return useRoute() as RouteLocationNormalizedLoaded & R;
}
